import React from "react";
import "./QuoteButton.css";

const QuoteButton = () => {
  return (
    <div className="cta stagger" data-animate>
      <p>
        The founders of the company have calibrated a research-based working environment to leverage the use of ultra-modern tools while empowering the structural and civil engineering fields by adopting latest 3D technologies, and providing advanced detailed solutions for all types of residential, commercial, and industrial projects, as per national and international standards such as AISC, ASCE & European standards.

      </p>

      <p>
       Our services are not just limited to providing excellent, and cost-effective solutions to the private and government sector, but also encouraging the principles of skilful designing, with exceptional quality and adequacy through the adoption of multiple latest software like STAAD Pro, ETABS, Tekla, Revit, idea Statica, and RAM connection.
      </p>

      <a href="#" className="btn">Get a Quote</a>
    </div>
  );
};

export default QuoteButton;
